import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Button,
  TextField,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead
} from "@material-ui/core";
import { Checkbox } from "@material-ui/core";
import axios from "axios";
import envConfig from "../../../bin/env.config";

import { useSelector } from "react-redux";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export default function DialogSelectBanners({open, onClose, project}) {
  const token = useSelector((state) => state.session.token);
  const [isLoading, setIsLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [serverUpdating, setServerUpdating] = useState(false);
  useEffect(() => {
    const getData = async () => {
      setIsLoading(true)
      let putData = {
         project_id:project.id,
      }; 
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/project-banners`;
      const result = await axios.post(url, putData, {
        headers: {
          Authorization: JSON.stringify(token),
        },
      });
      setDataSource(result.data.data);
      setIsLoading(false)
    };
    project&&open&&getData();
  }, [project,open]);
  useEffect(() => {
    const serverUpdate = async () => {
      
      let postData = {
        project_id:project.id,
        banners:[],
      }; 
      dataSource.map(item => {
        if(item.company_report_tool_project_id === project.id ){
          postData.banners.push({id:item.id,order_no:item.order_no})
        }
      })
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/project-banners-update`;
      const result = await axios.post(url, postData, {
        headers: {
          Authorization: JSON.stringify(token),
        },
      });
      setServerUpdating(false)   
      onClose&&onClose()   
    };
    serverUpdating&&serverUpdate();
  }, [serverUpdating]);
  const handleChange = (isChecked, selectedId) => {    
      let dataSourceTemp = dataSource.map(item=>{
        let itemTemp = item
        if(itemTemp.id===selectedId){
          // console.log(itemTemp)
          itemTemp.company_report_tool_project_id = !isChecked?project.id:0;
        }
        
        return itemTemp
      })
      setDataSource(dataSourceTemp)
  };
  const handleSave = () => { 
    setServerUpdating(true)
  };
  
  return (
      <Dialog
        //fullScreen
        open={open}
        onClose={onClose}
        TransitionComponent={Transition}
        aria-labelledby="Project Banners"
      >
        <DialogTitle>{project&&`Select banners for ${project.name}`}</DialogTitle>
        <DialogContent>
              <Table>
                  <TableHead>
                  <TableRow>
                    <TableCell align="right">#</TableCell>
                    <TableCell align="center">
                      {/* <Checkbox
                              id={`chk_banner_all`}
                              checked={selected.length ===store.banners.length}
                              onChange={() => handleChangeAll(selected.length ===store.banners.length)}
                      /> */}
                    </TableCell>
                    <TableCell align="center">Logo</TableCell> 
                    <TableCell align="left">Banner</TableCell> 
                    </TableRow>
                  </TableHead>
                  <TableBody>
                 {isLoading&&
                 <TableRow>
                  <TableCell colSpan={4}> Loading...</TableCell>
                  </TableRow>}
                 
                 {!isLoading&&(
                  <>
                    {dataSource.map((row, i) => {
                        let isChecked = Boolean(row.company_report_tool_project_id);
                        return (
                          <TableRow key={i} 
                             onClick={() => handleChange(isChecked, row.id)}>
                            <TableCell align="right">{i + 1}</TableCell>
                            <TableCell align="center">
                              <Checkbox
                                id={`chk_banner_${row.id}`}
                                checked={isChecked}
                                onChange={() => handleChange(isChecked, row.id)}
                              />
                            </TableCell> 
                            <TableCell align="center">
                                <img
                                  style={{width:"auto",height:"30px"}}
                                  src={row.company_logo_link}
                                />
                              </TableCell>                   
                            <TableCell>{row.name}</TableCell>                                
                            {/* <TableCell>{row.order_no}</TableCell>                                 */}
                          </TableRow>
                        );
                      })}
                  </>
                 )}
                 </TableBody>
                </Table>
        </DialogContent>      
        <DialogActions>
          <Button id="btn_banner_cancel" onClick={onClose} color="default">
            Cancel
          </Button>
          <Button id="btn_banner_save" autoFocus onClick={handleSave} color="primary">
            {serverUpdating?'Save ...':'Save'}
          </Button>
        </DialogActions>  
      </Dialog>
  );
}
